import * as z from "zod";

export const getGorgiasConnectionStatus = {
  name: "getGorgiasConnectionStatus" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    hasEscalationScope: z.boolean(),
    smsPhoneNumber: z.nullable(z.string()),
    smsEscalationEnabled: z.boolean(),
    needsEscalationReauth: z.boolean(),
    /** Gorgias rejected our credentials; the merchant must reconnect. */
    needsReauth: z.boolean(),
    /** Gorgias is rejecting new tickets because the account is over its messaging quota. */
    messagingQuotaExceeded: z.boolean(),
    /** Resolution webhook missing; resolved tickets won't sync back to Redo. */
    resolutionWebhookRegistered: z.boolean(),
  }),
};
